import { getCommunityScopeOptions } from 'shared/constants';
import i18n from 'shared/lib/i18n';

import { checkHasPermissions, isAdmin, loadUser } from '../../utils';

import { COMMUNITY_POST_TYPES } from './constants';

import permissions from '../../permissions';

const checkIsCommunityMember = (communityId) => {
  const currentUserCommunities = loadUser()?.communities || [];
  if (!currentUserCommunities?.length) return false;
  const isCommunityMember = currentUserCommunities.find(
    ({ id }) => id === communityId,
  )?.isCommunityMember;
  return isCommunityMember;
};

export const getIsShowJoinCommunity = (communityId) => {
  const isCommunityMember = checkIsCommunityMember(communityId);
  const hasOptInPermission =
    checkHasPermissions(permissions.opt_in_community) && !isAdmin();

  return !isCommunityMember && hasOptInPermission;
};

export const getCommunityPostsQuery = (
  q,
  community,
  communityType,
  avoidstatus = '',
) => {
  const type =
    communityType === getCommunityScopeOptions()[0].value ? '' : communityType;
  const queryParams = { q, community, type, avoidstatus };
  return queryParams;
};

export const getOlderCommentsCount = (olderComments, count) => {
  if (!olderComments?.offset) return 0;
  return count - olderComments.offset > 10 ? 10 : count - olderComments.offset;
};

export const getPersonPropertyInfo = (person) => {
  if (!person?.roles?.length) return '';
  return person.roles.reduce((propertyInfo, role) => {
    const currentPropertyInfo = role?.propertyName || '';
    if (propertyInfo.length) {
      return currentPropertyInfo
        ? `${propertyInfo}, ${currentPropertyInfo}`
        : propertyInfo;
    }
    return currentPropertyInfo;
  }, '');
};

export const getPostLabel = (type) => {
  let label = '';
  switch (type) {
    case COMMUNITY_POST_TYPES.post: {
      label = i18n.t('title.post');
      break;
    }
    case COMMUNITY_POST_TYPES.marketplace: {
      label = i18n.t('title.details');
      break;
    }
    case COMMUNITY_POST_TYPES.recommendation: {
      label = i18n.t('title.recommendation');
      break;
    }
    default:
      label = i18n.t('title.post');
  }
  return label;
};
